import React from 'react';
import styles from './ImportGameForm.module.scss';
import { Form } from '../../../components';
import { useStore } from '../../../../common';

const ImportGameForm = (): JSX.Element => {
	const [state] = useStore();
	const { importGameForm, success, infoText, formErrors } = state;
	const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.files && event.target.files.length > 0) {
			importGameForm.file = event.target.files[0];
		}
	};

	return (
		<section>
			<Form success={success}>
				<div className={styles.CreateGameForm}>
					<input type='file' onChange={handleFileChange} className={styles.input} placeholder='Add file' />
				</div>
				{formErrors && !!Object.keys(formErrors).length && (
					<div style={{ marginTop: 10, color: 'red' }}>
						{Object.values(formErrors).map((message, i) => (
							<p key={i}>{message}</p>
						))}
					</div>
				)}
				<p className={styles.note}>After the import, a report will be sent to your email.</p>
				{infoText?.error?.map((errorObj: any, i: number) =>
					Object.entries(errorObj).map(([gameIndex, messages]) => (
						<div key={`${i}-${gameIndex}`} style={{ marginTop: '10px', color: 'red' }}>
							<p>
								<strong>Line {gameIndex}:</strong>
							</p>
							<ul style={{ margin: 0, paddingLeft: '1em' }}>
								{(messages as string[]).map((msg, j) => (
									<li key={j}>{msg}</li>
								))}
							</ul>
						</div>
					))
				)}
				<a href={`${process.env.REACT_APP_BASE_URL}/common/import_example.csv`} download='import_example.csv'>
					Download Example
				</a>
			</Form>
		</section>
	);
};

export { ImportGameForm };
